import { render, staticRenderFns } from "./AdditionalServiceInput.vue?vue&type=template&id=7f964d63&scoped=true&"
import script from "./AdditionalServiceInput.vue?vue&type=script&lang=js&"
export * from "./AdditionalServiceInput.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServiceInput.vue?vue&type=style&index=0&id=7f964d63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f964d63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFadeTransition,VForm,VIcon,VTextField})
